import { useQuery } from '@tanstack/react-query';

import { getRelatedTasks } from '@/lib/api/generated/api';
import { expectStatus } from '@/lib/api/client';
import type { RelatedTasksResponse } from '@/lib/api/generated/model';
import { taskRelationsKeys } from '../queryKeys';

/** Fetched only while the dialog is open — a closed dialog has no use for it. */
export function useRelatedTasks(
  workspaceId: string,
  taskId: string,
  open: boolean,
) {
  return useQuery({
    queryKey: taskRelationsKeys.related(workspaceId, taskId),
    queryFn: async (): Promise<RelatedTasksResponse> =>
      expectStatus(
        await getRelatedTasks(workspaceId, taskId),
        200,
        'The related tasks could not be loaded.',
      ),
    enabled: open,
  });
}
